var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6706 10.5773L10.0074 18L3.34419 10.5773C2.90469 10.0962 2.5585 9.51806 2.32743 8.87914C2.09635 8.24022 1.98539 7.5544 2.00154 6.86487C2.01769 6.17535 2.16059 5.49705 2.42125 4.8727C2.68191 4.24834 3.05468 3.69146 3.51609 3.23711C3.97749 2.78275 4.51754 2.44078 5.10222 2.23272C5.6869 2.02466 6.30355 1.95502 6.91333 2.02819C7.52312 2.10135 8.11283 2.31574 8.64533 2.65784C9.17783 2.99995 9.64159 3.46236 10.0074 4.01597C10.3748 3.46638 10.8391 3.00801 11.3712 2.66953C11.9034 2.33106 12.4919 2.11977 13.1 2.04889C13.708 1.97801 14.3226 2.04907 14.9051 2.25762C15.4876 2.46616 16.0256 2.8077 16.4854 3.26087C16.9452 3.71404 17.3169 4.26907 17.5772 4.89124C17.8375 5.5134 17.9808 6.1893 17.9982 6.87664C18.0156 7.56397 17.9067 8.24795 17.6782 8.88575C17.4498 9.52355 17.1068 10.1015 16.6706 10.5833",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconFavorite);
export default __webpack_public_path__ + "static/media/buttonIconFavorite.953200ba972fde0536a2c652b2e6d537.svg";
export { ForwardRef as ReactComponent };